module.exports = __webpack_public_path__ + "static/media/download.a45bdd3f.svg";